var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GenreView',{attrs:{"publications":_vm.publications,"searcher":_vm.searcher,"sort-strategy":_vm.sortStrategy,"custom-counter":_vm.customCounter,"genre":_vm.genre}}),_vm._v(" "),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }